import { render, staticRenderFns } from "./OrganizerSetup.vue?vue&type=template&id=00e6048b&scoped=true"
import script from "./OrganizerSetup.vue?vue&type=script&lang=js"
export * from "./OrganizerSetup.vue?vue&type=script&lang=js"
import style0 from "./OrganizerSetup.vue?vue&type=style&index=0&id=00e6048b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e6048b",
  null
  
)

export default component.exports